import clsx from "clsx"
import React, { InputHTMLAttributes } from "react"

interface NeloTextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean
}

const NeloTextInput: React.FC<NeloTextInputProps> = ({ value, error, className, ...props }) => {
  const baseClasses = `
    w-full p-3 border border-nelo-dark-gray rounded-lg
    focus:outline-none focus:ring-2 focus:ring-nelo-blue focus:border-transparent
    font-nunito
  `

  const hasValueClasses = `
    ring-2 ring-nelo-blue border-transparent bg-nelo-sky-50
  `

  const errorClasses = `
    ring-2 ring-red-500 border-transparent bg-red-50
  `

  const finalClassName = clsx(baseClasses, !!value && !error && hasValueClasses, error && errorClasses, className)

  return <input {...props} value={value} className={finalClassName} />
}

export default NeloTextInput
